import React, {useEffect, useRef} from 'react';
import { endpoints } from 'Core/defaultValues';

const ZpassView = () => {
    const iframeRef = useRef(null);

    // Get the token from localStorage
    const idToken = localStorage.getItem("IdToken");
    const refreshToken = localStorage.getItem("RefreshToken");
    const username = localStorage.getItem("username");

    const params = new URLSearchParams({
        pxLogin: 'true',
        
    });
    let paramsAsString = params.toString();
    const url = `${endpoints.ZONAR_ZPASS_APP_URL}/?${paramsAsString}`;
    

    useEffect(() => {
        const sendToken = () => {
            if (iframeRef.current && iframeRef.current.contentWindow && idToken) {;
                iframeRef.current.contentWindow.postMessage(
                    { idToken, refreshToken, username }, url
                );
            }
        };

        // Send the token once the iframe loads
        const iframe = iframeRef.current;
        if (iframe) {
            iframe.onload = sendToken;
        }
    }, [idToken]); // Re-run if the token changes

    return (
        <div style={{ height: '95vh' }}>
            <iframe
                ref={iframeRef}
                title="Z Pass"
                width="100%"
                height="100%"
                src={url}
            />
        </div>
    );
}

export default ZpassView;
